<template>
    <div class="row">
        <div class="col-12 mb-3">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'checkpoints' }">Checkpoints</el-breadcrumb-item>
                <el-breadcrumb-item v-if="$route.params.checkpointId">Edit</el-breadcrumb-item>
                <el-breadcrumb-item v-else>Create</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <tabs>
                    <tab-pane label="General Information">
                        <form class="form-horizontal">
                            <!-- NAME -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Name *</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="checkpoint.name"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Description -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Description</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="checkpoint.description" type="textarea"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Type -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Description</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="checkpoint.type" label="unique">Unique</el-radio>
                                        <el-radio v-model="checkpoint.type" label="multiple">Multiple</el-radio>
                                    </div>
                                </div>
                            </div>
                            <!-- Fields to show -->

                            <div class="row">
                                <label class="col-sm-2 col-form-label">Fields to be shown in checkin page & attendees page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <CustomSelect multiple v-model="checkpoint.fieldsForCheckinAndAttendeesPage" :options="getOptions" />
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end">
                                <el-button
                                    @click="submit()"
                                    :loading="saving"
                                    type="primary"
                                    class="btn btn-primary">
                                        Save
                                </el-button>
                            </div>
                        </form>
                    </tab-pane>
                    <!-- <tab-pane v-if="$route.params.checkpointId" label="Attendees">
                        <el-table :data="checkpoint.attendees">
                            <el-table-column label="Name">
                                <template slot-scope="props">
                                    {{ props.row | registrationName }}
                                </template>
                            </el-table-column>
                            <el-table-column label="Timestamp">
                                <template slot-scope="props">
                                    <p
                                        v-if="checkpoint.timestamps[props.row._id]"
                                        v-for="(timestamp, index) in checkpoint.timestamps[props.row._id]"
                                        :key="`registration-${props.row._id}-timestamp-${index}`"
                                        class="m-0">
                                            {{ timestamp | formatTimestamp }}
                                    </p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </tab-pane> -->
                </tabs>
            </card>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import CustomSelect from '../../components/CustomSelect.vue'
import http from '../../http'
import { mapState } from 'vuex';

export default {
    components: {
        CustomSelect
    },
    data () {
        return {
            saving: false,
            loading: false,
            checkpoint: {
                name: '',
                description: '',
                type: 'unique',
                fieldsForCheckinAndAttendeesPage: []
            },
            checkpointFields:[]
        }
    },
    mounted () {
        this.getData()
    },
    computed:{
        ...mapState(['fields']),
        getOptions(){
            let arr = []
            this.checkpointFields.forEach(f =>{
                arr.push({
                    label: f.name,
                    value: f._id
                })
            })
            this.fields.forEach(f =>{
                arr.push({
                    label: f.name,
                    value: f._id
                })
            })

            return arr;
        }
    },
    methods: {
        submit: async function () {
            try {
                this.saving = true
                if (this.$route.params.checkpointId) {
                    await this.$store.dispatch('update', {
                        path: 'checkpoints',
                        id: this.$route.params.checkpointId,
                        data: this.checkpoint
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', {
                        path: 'checkpoints',
                        data: {
                            ...this.checkpoint,
                            eventId: this.$route.params.eventId
                        }
                    })
                    this.$notify('Checkpoint was successfully created!')
                    this.$router.push({ name: 'checkpoints' })
                }
            } catch (e) {
                console.log('error creating new checkpoint')
            }
            this.saving = false
        },
        getData: async function () {
            this.loading = true

            try {
                const res = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`)
                this.checkpointFields = res.data.fields;
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }

            let params = { filters: { eventId: this.$route.params.eventId } }
            if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })

            try {
                if (!this.$route.params.checkpointId) {
                    this.loading = false
                    return
                }

                const response = await this.$store.dispatch('get', { path: 'checkpoints', key: 'checkpoint', id: this.$route.params.checkpointId })
                this.checkpoint = response.data.checkpoint
            } catch (e) {
                console.log('error getting checkpoint')
            }

            this.loading = false
        }
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    }
}
</script>
